import { Button, Cell, Grid, Heading, HFlow, Icon } from 'bold-ui'
import { Box } from 'components/Box'
import {
  CheckboxField,
  EquipeSelectField,
  Form,
  FormRenderProps,
  SubmitButton,
  UnidadeSaudeSelectField,
} from 'components/form'
import { resolveName } from 'components/form/final-form/hooks/useField'
import { FormApi } from 'final-form'
import createDecorator from 'final-form-calculate'
import { TipoRegulacaoEnum } from 'graphql/types.generated'
import { MetaPath, MetaRoot } from 'util/metaPath'

import { listaRegulacaoFilterCalculator } from '../calculator-regulacao'
import { ListaRegulacaoFilterModel, ListaRegulacaoTableFilterModel, RegulacaoEnumTextMap } from '../model-regulacao'
import { StatusRegulacaoSelectField } from './TipoRegulacaoSelectField'

interface ListaRegulacaoFilterProps {
  path: MetaPath<ListaRegulacaoTableFilterModel> | MetaRoot<ListaRegulacaoTableFilterModel>
  filter: ListaRegulacaoFilterModel
  updateFilter(filter: ListaRegulacaoFilterModel): void
}

const decorator = createDecorator(...listaRegulacaoFilterCalculator)

export const ListaRegulacaoFilter = (props: Readonly<ListaRegulacaoFilterProps>) => {
  const { path, filter, updateFilter } = props

  const onSubmit = (tableFilter: ListaRegulacaoTableFilterModel) => {
    updateFilter({ ...filter, tableFilter })
  }

  const limparCampos = (form: FormApi<ListaRegulacaoTableFilterModel>) => {
    form.reset()
    form.change(resolveName(path.unidadeSaude), null)
    form.change(resolveName(path.equipe), null)
    form.change(resolveName(path.tipoRegulacao), null)
    form.change(resolveName(path.statusRegulacao), null)
    form.change(resolveName(path.solicitantes), null)
  }

  const renderForm = (formProps: FormRenderProps<ListaRegulacaoTableFilterModel>) => {
    return (
      <Grid gap={0} gapVertical={1} style={{ padding: '1rem 0 2rem 0' }}>
        <Heading level={3} fontWeight='bold'>
          Buscar solicitação
        </Heading>
        <Cell size={12} style={{ padding: '1.5rem 0 1rem 0' }}>
          <Box label='Cidadão vinculado à'>
            <Grid>
              <Cell size={6}>
                <UnidadeSaudeSelectField
                  name={path.unidadeSaude}
                  label='Unidade de saúde responsável'
                  placeholder='Todos os cidadãos do município'
                />
              </Cell>
              <Cell size={6}>
                <EquipeSelectField
                  name={path.equipe}
                  label='Equipe responsável'
                  placeholder='Todas as equipes e cidadãos sem equipe'
                  showSemEquipeOption
                  unidadeSaudeId={formProps.values?.unidadeSaude?.id}
                  disabled={!formProps.values?.unidadeSaude?.id}
                  mostrarInativas={true}
                />
              </Cell>
            </Grid>
          </Box>
        </Cell>
        <Cell size={12}>
          <Box label='Tipo de solicitação' style={{ width: 'fit-content' }}>
            <HFlow hSpacing={1}>
              <CheckboxField
                name={path.tipoRegulacao}
                label={RegulacaoEnumTextMap[TipoRegulacaoEnum.SOLICITACAO_EXAME_COMUM]}
                value={TipoRegulacaoEnum.SOLICITACAO_EXAME_COMUM}
              />
              <CheckboxField
                name={path.tipoRegulacao}
                label={RegulacaoEnumTextMap[TipoRegulacaoEnum.SOLICITACAO_EXAME_ALTO_CUSTO]}
                value={TipoRegulacaoEnum.SOLICITACAO_EXAME_ALTO_CUSTO}
              />
              <CheckboxField
                name={path.tipoRegulacao}
                label={RegulacaoEnumTextMap[TipoRegulacaoEnum.GUIA_ENCAMINHAMENTO]}
                value={TipoRegulacaoEnum.GUIA_ENCAMINHAMENTO}
              />
              <CheckboxField
                name={path.tipoRegulacao}
                label={RegulacaoEnumTextMap[TipoRegulacaoEnum.SOLICITACAO_EXAME_OCI]}
                value={TipoRegulacaoEnum.SOLICITACAO_EXAME_OCI}
              />
            </HFlow>
          </Box>
        </Cell>
        <Cell size={12}>
          <Grid>
            <Cell size={6}>
              <StatusRegulacaoSelectField name={path.statusRegulacao} label='Status' />
            </Cell>
            <Cell size={6} />
          </Grid>
        </Cell>
        <Cell size={12} alignSelf='flex-end'>
          <HFlow justifyContent='flex-end'>
            <Button kind='normal' size='medium' onClick={() => limparCampos(formProps.form)}>
              <Heading level={5} fontWeight='bold'>
                Limpar campos
              </Heading>
            </Button>
            <SubmitButton size='medium' handleSubmit={formProps.handleSubmit}>
              <Icon icon='zoomOutline' />
              <Heading level={5} fontWeight='bold' style={{ color: 'white' }}>
                Buscar
              </Heading>
            </SubmitButton>
          </HFlow>
        </Cell>
      </Grid>
    )
  }

  return (
    <Form<ListaRegulacaoTableFilterModel>
      render={renderForm}
      onSubmit={onSubmit}
      decorators={[decorator]}
      initialValues={filter.tableFilter}
    />
  )
}
